<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-xs-12">
        <a class="btn btn-default btn-sm" :href="shipping" target="_blank"><i class="fa fa-qrcode mr-5"></i>{{'ship' | translate}}</a>
      </div>
      <div class="col-md-8 col-xs-12">
        <template v-for="t in transitions">
          <ul v-if="t.type === 'shipping'">
            <li v-for="i in t.transitions">{{i.transition}} - <span class="italic">{{i.date | orderDate}}<i class="fa fa-clock-o mr-5 ml-5"></i>{{i.date | orderDate(true)}}</span></li>
          </ul>
        </template>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-md-4 col-xs-12">
        <a class="btn btn-default btn-sm" :href="returnCode" target="_blank"><i class="fa fa-qrcode mr-5"></i>{{'return_item' | translate}}</a>
      </div>
      <div class="col-md-8 col-xs-12">
        <template v-for="t in transitions">
          <ul v-if="t.type === 'return'">
            <li v-for="i in t.transitions">{{i.transition}} - <span class="italic">{{i.date | orderDate}}<i class="fa fa-clock-o mr-5 ml-5"></i>{{i.date | orderDate(true)}}</span></li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['transitions', 'shipping', 'returnCode'],
    data () {
      return {
        show: true
      }
    },
    methods: {
      getClass (e) {
        switch (e) {
          case 'transit':
            return {icon: 'fa fa-truck', style: 'text-info'}
          case 'label_created':
            return {icon: 'fa fa-cloud-download', style: 'text-success'}
          case 'picked_up':
            return {icon: 'fa fa-truck', style: 'text-info'}
          case 'out_for_delivery':
            return {icon: 'fa fa-truck', style: 'text-teal'}
          case 'delivered':
            return {icon: 'fa fa-check', style: 'text-success'}
          case 'awaits_pickup_by_receiver':
            return {icon: 'fa fa-cube', style: 'text-warning'}
          case 'canceled':
            return {icon: 'fa fa-times', style: 'text-danger'}
          case 'delayed':
            return {icon: 'fa fa-clock-o', style: 'text-warning'}
          case 'exception':
            return {icon: 'fa fa-exclamation-triangle', style: 'text-warning'}
          case 'not_delivered':
            return {icon: 'fa fa-ban', style: 'text-danger'}
          case 'destroyed':
            return {icon: 'fa fa-bolt', style: 'text-danger'}
          case 'notification':
            return {icon: 'fa fa-info', style: 'text-info'}
          case 'unknown':
            return {icon: 'fa fa-question', style: 'text-primary'}
          default:
            return {icon: 'fa fa-lightbulb-o', style: 'text-primary'}
        }
      }
    },
    watch: {
      transitions () {
      }
    }
  }
</script>
<style>
    .italic {
        font-style: italic;
    }
</style>



// WEBPACK FOOTER //
// src/components/tools/LabelHistory.vue